/**
 * DeviceBanner — "On this device" notice in the v3 history sidebar/drawer
 * (T6/T8). Purely informational: there is no sign-in flow yet, so this is
 * copy only, no button. Purely presentational (no state/handlers) — stays a
 * server component.
 */
import { Smartphone } from 'lucide-react';
import { cn } from '@/lib/utils';
import { V3_COLORS } from '@/lib/design-tokens';

/** Literal per spec — the icon/body copy color doesn't have a dedicated
 *  token (V3_COLORS.dateTileInPersonMonth happens to share this hex but is
 *  semantically a date-tile color, not this banner's). */
const BODY_COLOR = '#B0863C';

/** Sign-in doesn't exist yet (device-only identity) — hide the nudge until
 *  auth ships. Flip to true to restore "Sign in to see them anywhere." */
const SHOW_SIGN_IN_NUDGE = false;

export interface DeviceBannerProps {
  className?: string;
}

export function DeviceBanner({ className }: DeviceBannerProps) {
  return (
    <div
      className={cn(
        'mx-1.5 mb-2.5 mt-1 flex items-start gap-2 rounded-[11px] border-[1px] px-[12px] py-2.5',
        className
      )}
      style={{
        backgroundColor: V3_COLORS.amberBg,
        borderColor: V3_COLORS.amberBorder,
      }}
    >
      <Smartphone
        aria-hidden="true"
        size={14}
        className="mt-0.5 shrink-0"
        style={{ color: BODY_COLOR }}
      />
      <div className="flex flex-col gap-0.5">
        <div
          className="text-[12.5px] font-bold"
          style={{ color: V3_COLORS.amberText }}
        >
          On this device
        </div>
        <div
          className="text-[12px] leading-[1.5]"
          style={{ color: BODY_COLOR }}
        >
          These chats stay with this browser.
          {SHOW_SIGN_IN_NUDGE && ' Sign in to see them anywhere.'}
        </div>
      </div>
    </div>
  );
}
